import React from 'react';

const AnalysisSummaryCard = ({ color, name, type, totalEmpreendimentos, ofertaLancada, ofertaFinal, unidadesVendidas, valorMedioUnidades, valorMedioMetroQuadrado, onRemove }) => (
    <div className="info-card area-info ov-hidden" style={{ borderLeft: `4px solid ${color}` }}>
        <div className="info-card-header card-header" style={{ backgroundColor: color, color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <strong>{name || type || 'Área'}</strong>
            {onRemove && (
                <button onClick={onRemove} className="mapbox-area-remove-btn" style={{ color: '#fff', fontSize: 16 }} title="Remover área">
                    <i className="fas fa-times"></i>
                </button>
            )}
        </div>
        <div className="card-body card-body-mapa-info">
            <div className="font19"><span className="info-card-label">Total de empreendimentos:</span> {totalEmpreendimentos}</div>
            <div className="font19"><span className="info-card-label">Oferta lançada:</span> {ofertaLancada}</div>
            <div className="font19"><span className="info-card-label">Oferta final:</span> {ofertaFinal}</div>
            <div className="font19"><span className="info-card-label">Unidades vendidas:</span> {unidadesVendidas}</div>
            {valorMedioUnidades && valorMedioUnidades !== '0,00' && (
                <div className="font19"><span className="info-card-label">Valor médio:</span> R$ {valorMedioUnidades}</div>
            )}
            {valorMedioMetroQuadrado && valorMedioMetroQuadrado !== '0,00' && (
                <div className="font19"><span className="info-card-label">Valor médio m²:</span> R$ {valorMedioMetroQuadrado}</div>
            )}
        </div>
    </div>
);

export default AnalysisSummaryCard;
